(() => {
  if (customElements.get('charbon-reservation')) return;

  customElements.define('charbon-reservation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.attempts = 0;
      this.button = this.querySelector('[data-reservation-open]');
      this.status = this.querySelector('[data-reservation-status]');
      this.button?.addEventListener('click', () => this.openWidget(), { signal: this.controller.signal });
      // Defer until the app's current boot task has finished binding its handlers.
      this.timer = setTimeout(() => this.waitForWidget(), 0);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }

    waitForWidget() {
      if (!this.isConnected) return;
      if (typeof window.PickASpot?.open === 'function') {
        if (this.button) this.button.hidden = false;
        if (this.status) this.status.hidden = true;
        if (this.dataset.autoOpen === 'true' && !this.hasAttribute('data-design-mode') && !this.autoOpened) {
          this.autoOpened = true;
          void this.openWidget();
        }
        return;
      }
      // App embeds can load after the section. Stop if the app is unavailable.
      if (++this.attempts < 80) {
        this.timer = setTimeout(() => this.waitForWidget(), 250);
      } else if (this.status) {
        this.status.hidden = false;
      }
    }

    async openWidget() {
      if (this.opening) return;
      this.opening = true;
      try {
        if (typeof window.PickASpot?.open !== 'function') throw new Error('Widget unavailable');
        await window.PickASpot.open();
        if (this.status) this.status.hidden = true;
      } catch {
        if (this.status) this.status.hidden = false;
      } finally {
        this.opening = false;
      }
    }
  });
})();
